import ApolloClient from 'apollo-client'
import VueApollo from 'vue-apollo'
import {GraphQLNetworkInterface} from '@/setup/GraphQLNetworkInterface'

export const networkInterface = new GraphQLNetworkInterface('https://cbc.jackalope.technology/api/queries')

const apolloClient = new ApolloClient({
  networkInterface,
})

export default apolloClient

export const apolloProvider = new VueApollo({
  clients: {
    a: apolloClient,
  },
  defaultClient: apolloClient,
})



// WEBPACK FOOTER //
// ./src/setup/apollo.js